import { render, staticRenderFns } from "./RoundPlayers.vue?vue&type=template&id=071d01ea&scoped=true"
import script from "./RoundPlayers.vue?vue&type=script&lang=js"
export * from "./RoundPlayers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071d01ea",
  null
  
)

export default component.exports